<template>
  <a-input-search
    ref="searchInput"
    class="ll-search"
    :disabled="disabled || loading"
    :loading="loading"
    :placeholder="placeholder"
    allow-clear
    @input="handleInput"
    @search="handleSearch"
  >
    <template #addonBefore><lander-icon type="search" /></template>
  </a-input-search>
</template>

<script>
export default {
  name: 'LanderSearch',
  props: {
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Search...' },
    autoFocused: { type: Boolean, default: false },
  },
  mounted() {
    if (this.autoFocused) this.focus();
  },
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value);
      if (!event.target.value) this.$emit('search', '');
    },
    handleSearch(value) {
      if (value) this.$emit('search', value);
    },
    focus() {
      this.$nextTick(() => {
        if (this.$refs.searchInput) this.$refs.searchInput.focus();
      });
    },
  },
};
</script>

<style>

</style>
